"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIBF = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
var instances_1 = require("../../../types/instances");
var navigation_1 = require("../../../types/navigation");
var brands_1 = require("../../brands");
var environments_1 = require("../../environments");
var localesAndRegions_1 = require("../../localesAndRegions");
var navigation_2 = require("../../navigation");
exports.LIBF = {
    brand: brands_1.BrandName.LIBF,
    region: localesAndRegions_1.RegulatoryRegion.UK,
    deployment: instances_1.MondrianDeploymentType.AMPLIFY,
    company: 'LIBF',
    microFrontends: [
        'auth',
        'core',
        'dashboard',
        'dev-overlay',
        'directories',
        'exam',
        'gradeview',
        'learn',
        'navbar',
        'news',
        'payment',
        'profile',
        'static-pages',
        'student-calendar',
        'student-document',
        'student-service-desk',
        'study-plan',
        'user-experience-and-feedback',
    ],
    redirects: [{ from: '/', to: '/home' }],
    apiBaseUrl: (_a = {},
        _a[environments_1.Environment.DEV] = 'https://api1.aws-dev.libf.ac.uk',
        _a[environments_1.Environment.NONPROD] = 'https://api1.aws-stage.libf.ac.uk',
        _a[environments_1.Environment.PROD] = 'https://api1.aws-prod.libf.ac.uk',
        _a),
    moodleBaseUrl: (_b = {},
        _b[environments_1.Environment.DEV] = 'https://dev.mycampus-classic.libf.ac.uk',
        _b[environments_1.Environment.NONPROD] = 'https://stage.mycampus-classic.libf.ac.uk',
        _b[environments_1.Environment.PROD] = 'https://mycampus-classic.libf.ac.uk',
        _b),
    auth0: (_c = {},
        _c[environments_1.Environment.DEV] = {
            domain: 'dev.auth.libf.ac.uk',
            clientId: 'LSYnKORk35dvXndbFkWvcEEk9lqGfPsY',
            audience: 'https://api.libf.ac.uk',
        },
        _c[environments_1.Environment.NONPROD] = {
            domain: 'stage.auth.libf.ac.uk',
            clientId: 'ZbfkJR3IKHcABTBA7KqPyEnAUkeNMGIq',
            audience: 'https://api.libf.ac.uk',
        },
        _c[environments_1.Environment.PROD] = {
            domain: 'auth.libf.ac.uk',
            clientId: '4gp5iY5rNgv24W5iKeczInoJ94emmqIm',
            audience: 'https://api.libf.ac.uk',
        },
        _c),
    meta: {
        title: 'myCampus - LIBF',
        description: 'myCampus - Embark on your learning journey with the ultimate platform focused on you and your studies!',
        keywords: [],
    },
    aws: (_d = {},
        _d[environments_1.Environment.PROD] = {
            domain: 'aws-prod.libf.ac.uk',
        },
        _d[environments_1.Environment.NONPROD] = {
            domain: 'aws-stage.libf.ac.uk',
        },
        _d[environments_1.Environment.DEV] = {
            domain: 'aws-dev.libf.ac.uk',
        },
        _d),
    hostname: (_e = {},
        _e[environments_1.Environment.PROD] = {
            domain: 'mycampus.libf.ac.uk',
            allowImportMapOverrides: false,
        },
        _e[environments_1.Environment.NONPROD] = {
            domain: 'mycampus.libf.ac.uk',
            subDomain: 'stage',
            allowImportMapOverrides: true,
        },
        _e[environments_1.Environment.DEV] = {
            domain: 'mycampus.libf.ac.uk',
            subDomain: 'dev',
            allowImportMapOverrides: true,
        },
        _e),
    navigation: function () {
        var _a;
        return _a = {},
            _a[navigation_1.NavigationType.SIDE] = [
                navigation_2.navigationItems.home,
                navigation_2.navigationItems.learn,
                navigation_2.navigationItems.news,
                navigation_2.navigationItems.community,
                navigation_2.navigationItems.studyManagement,
                navigation_2.navigationItems.infoCenter,
                navigation_2.navigationItems.faq,
            ],
            _a[navigation_1.NavigationType.BOTTOM] = [
                navigation_2.navigationItems.dataPrivacy,
                navigation_2.navigationItems.legal,
            ],
            _a;
    },
};
